/**
 * Odmowa wniosku urlopowego ma nazwany powód (Fala 7, grupy 24, 35 i 44).
 *
 * Kody pochodzą z jednej listy w `@k1p4/shared` (`LEAVE_REQUEST_ERROR_CODES`),
 * z której korzysta walidacja wniosku w API. Mapa jest pełna z typu, a test
 * „każdy kod odmowy ma tłumaczenie" pilnuje, że każdy klucz istnieje w PL i EN
 * — nowy powód bez zdania wyszedłby na ekran jako „coś poszło nie tak".
 */
import { LEAVE_REQUEST_ERROR_CODES, type LeaveRequestErrorCode } from '@k1p4/shared'

export const LEAVE_ERROR_KEYS: Record<LeaveRequestErrorCode, string> = {
  UNKNOWN_TYPE: 'portal.leaves.errorUnknownType',
  LEAVE_NOT_APPLICABLE: 'portal.leaves.errorNotApplicable',
  OUTSIDE_EMPLOYMENT: 'portal.leaves.errorOutsideEmployment',
  NO_WORKING_DAYS: 'portal.leaves.errorNoWorkingDays',
  OVERLAP: 'portal.leaves.errorOverlap',
  INSUFFICIENT_BALANCE: 'portal.leaves.errorBalance',
}

function isLeaveErrorCode(code: string): code is LeaveRequestErrorCode {
  return (LEAVE_REQUEST_ERROR_CODES as readonly string[]).includes(code)
}

/** Klucz i18n dla kodu odmowy; nieznany kod (np. błąd sieci) — zdanie ogólne. */
export function leaveErrorKey(code: string | null | undefined): string {
  return code && isLeaveErrorCode(code) ? LEAVE_ERROR_KEYS[code] : 'portal.leaves.errorGeneric'
}
